import React from "react";
import { Outlet } from "react-router-dom";
import Menu from "./components/Menu";
import Footer from "~/landingPage/components/Footer";
import BackToTopButton from "~/landingPage/components/BackToTopButton";
import { WhatsAppChat } from "~/landingPage/components/WhatsAppChat";

export default function LandingPagePublicLayout({ menuItems }) {
  return (
    <div className="h-screen w-screen">
      <Menu items={menuItems} />
      <div className="w-screen text-gray-700 overflow-x-hidden">
        <Outlet />
      </div>
      <Footer />
      <WhatsAppChat />
      <BackToTopButton />
    </div>
  );
}
